import { CategoryPageSectionType } from '../../types/TemplateConfiguration'
import { PAGEHEADER_TYPES } from '../../components/header/PageHeaderContainer'

export const getCtaSkinColor = (ctasWithUrlLength: number, ctaIndex: number): 'primary' | 'secondary' => {
  if (ctasWithUrlLength === 2) {
    return ctaIndex === 0 ? 'primary' : 'secondary'
  } else {
    return 'primary'
  }
}

export const isOfTypePageHeader = (sectionType: CategoryPageSectionType) => {
  return PAGEHEADER_TYPES.includes(sectionType)
}

export const getFontFamilyType = (isPageHeader: boolean, selectedFontFamily?: string) => {
  let fontFamily
  if (isPageHeader && selectedFontFamily && selectedFontFamily !== 'Graphik') {
    fontFamily = 'special'
  }
  return fontFamily
}

export const getFontFamilyWeight = (isPageHeader: boolean, selectedFontFamily?: string) => {
  let fontWeight
  if (isPageHeader && selectedFontFamily && selectedFontFamily !== 'Graphik') {
    fontWeight = 'normal'
  }
  return fontWeight
}
